import { type ReportAccessGrant } from '@webapp/platform/iam/entities/ReportAccessGrant'
import { useReportAccessGrantListPresenter } from './useReportAccessGrantListPresenter'
import { ReportAccessGrantListView } from '../../views/ReportAccessGrantListView'

export interface IReportAccessGrantListPresenterProps {
  secondaryCategoryId: number
  highlightedGrantId: number | undefined
  onRemoveGrant: (grant: ReportAccessGrant) => void
  onClearAll: (grants: ReportAccessGrant[]) => void
}

export const ReportAccessGrantListPresenter = ({
  secondaryCategoryId,
  highlightedGrantId,
  onRemoveGrant,
  onClearAll,
}: IReportAccessGrantListPresenterProps) => {
  const {
    data: { grants },
    states: { isLoading },
  } = useReportAccessGrantListPresenter({ secondaryCategoryId })

  return (
    <ReportAccessGrantListView
      grants={grants}
      highlightedGrantId={highlightedGrantId}
      isLoading={isLoading}
      onRemoveGrant={onRemoveGrant}
      onClearAll={onClearAll}
    />
  )
}

ReportAccessGrantListPresenter.displayName = 'ReportAccessGrantListPresenter'
